import React from 'react';
import './Media.css';
import mediaArt from '../media/media_art.jpg';

const Media: React.FC = () => {
  const mixclouds = [
    {
      title: "UK Garage",
      date: "10/02/2022",
      url: "https://www.mixcloud.com/widget/iframe/?hide_cover=1&feed=%2Fdj_boogiebrown%2Fukg%2F"
    },
    {
      title: "UK Fresh (Live Broadcast)",
      date: "2/19/2022",
      url: "https://www.mixcloud.com/widget/iframe/?hide_cover=1&feed=%2Fdj_boogiebrown%2Fdj-boogie-brown-live-20220104-205256%2F"
    },
    {
      title: "Acapellas vs Instrumentals",
      date: "10/23/2021",
      url: "https://www.mixcloud.com/widget/iframe/?hide_cover=1&feed=%2Fdj_boogiebrown%2Fdj-boogie-brown-live-20211023-210031%2F"
    },
    {
      title: "Summer of Love 1 and 2 (Live Broadcast)",
      date: "7/3/2022",
      url: "https://www.mixcloud.com/widget/iframe/?hide_cover=1&feed=%2Fdj_boogiebrown%2Fdj-boogie-brown-live-20210703-205826%2F"
    },
    {
      title: "Freestyle #3",
      date: "6/5/2021",
      url: "https://www.mixcloud.com/widget/iframe/?hide_cover=1&feed=%2Fdj_boogiebrown%2Ffreestyle-3-mic-free%2F"
    },
    {
      title: "Freestyle #2",
      date: "5/2/2021",
      url: "https://www.mixcloud.com/widget/iframe/?hide_cover=1&feed=%2Fdj_boogiebrown%2Ffreestyle-2%2F"
    },
    {
      title: "R&B/Hip-Hop - Vol 2",
      date: "4/24/2021",
      url: "https://www.mixcloud.com/widget/iframe/?hide_cover=1&feed=%2Fdj_boogiebrown%2Frbhiphop-vol-2-mic-free%2F"
    },
    {
      title: "R&B/Hip-Hop - Vol 1",
      date: "3/28/2021",
      url: "https://www.mixcloud.com/widget/iframe/?hide_cover=1&feed=%2Fdj_boogiebrown%2Frbhiphop-vol-1%2F"
    }
  ];

  const youtubes = [
    {
      title: "New Jack Swing",
      date: "1/24/2021",
      url: "https://www.youtube.com/embed/-iTSNB_k73w"
    }
  ];

  return (
    <div className="media page-container">
      <div className="page-image-column">
        <img src={mediaArt} alt="Media" />
      </div>
      <div className="page-content-column">
        <h2>MIXCLOUD SETS</h2>
        <div className="media-streams">
          {mixclouds.map((mix, index) => (
            <div key={index} className="stream-item">
              <h3>{mix.title.toUpperCase()}</h3>
              <p className="stream-date">RECORDED: {mix.date}</p>
              <iframe 
                className="media-player" 
                title={mix.title}
                src={mix.url} 
                frameBorder="0"
              ></iframe>
            </div>
          ))}
        </div>

        <h2>YOUTUBE VIDEOS</h2>
        <div className="media-streams">
          {youtubes.map((video, index) => (
            <div key={index} className="stream-item">
              <h3>{video.title.toUpperCase()}</h3>
              <p className="stream-date">RECORDED: {video.date}</p>
              <iframe 
                className="media-player" 
                title={video.title}
                src={video.url} 
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Media;
